import React, { FC } from "react";
import Svg, { Path, Line } from "react-native-svg";
import { ICustomSvgProps } from "./AngryIcon";

const FoldersIcon: FC<ICustomSvgProps> = (props) => {
    return (
      <Svg
        width={props.width || 35}
        height={props.height || 35}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
          <Path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
          <Line x1="7" y1="7" x2="7.01" y2="7"/>
      </Svg>
    );
};

export default FoldersIcon;